















































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import StoreSuketKlaimProtesaGigi from "@/store/modules/SuketKlaimProtesaGigi";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import { storeDokter } from "@/store/modules/dokter";
import { KlaimProtesaGigiWithRelationship } from "@/types/suket_klaim_protesa_gigi";

import pdf from "vue-pdf";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    pdf,
  },
})
export default class SuketKlaimProtesaGigiTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["03", "2I", "1A", "1B", "1C", "1D", "1E"];
  suketSvc = new CommonSuket(EnSuketCategory.KlaimProtesaGigi);
  suketStore = StoreSuketKlaimProtesaGigi;

  // Notasi FDI two-digit (ISO 3950) — orientasi klinis (kanan pasien di kiri).
  maxilla = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28];
  mandibula = [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38];

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(
          EnSuketCategory.KlaimProtesaGigi,
          this.dataSuket.id
        )
      : null;
  }

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  umur = getAge(formatDMYDate(this.pasien.tgl_lahir)).toString().concat(" Th");
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;
  jenis_protesa = null;
  material = null;
  warna = null;
  elemen_gigi: number[] = [];
  indikasi_spesialistik = null;
  tgl_pemasangan = null;
  catatan_pemasangan = null;
  validasi = [(v) => !!v || "*Kolom ini harus diisi"];
  saving = false;
  loadedRatio = 0;

  mounted() {
    this.fillFromData(this.dataSuket);
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  get elemenGigiSorted() {
    return [...this.elemen_gigi].sort((a, b) => a - b);
  }

  toggleTooth(t: number) {
    if (this.isReadOnly) return;
    const idx = this.elemen_gigi.indexOf(t);
    if (idx === -1) {
      this.elemen_gigi.push(t);
    } else {
      this.elemen_gigi.splice(idx, 1);
    }
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        jenis_protesa: this.jenis_protesa,
        material: this.material,
        warna: this.warna,
        elemen_gigi: this.elemenGigiSorted,
        indikasi_spesialistik: this.indikasi_spesialistik,
        tgl_pemasangan: this.tgl_pemasangan,
        catatan_pemasangan: this.catatan_pemasangan,
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id,
    };
  }

  fillFromData(val: KlaimProtesaGigiWithRelationship) {
    if (val) {
      this.register_id = val.register_id;
      this.pasien_rm = val.pasien_rm.toString();
      this.unit_id = val.unit_id;
      this.umur = val.pasien?.umur_th || this.umur;
      this.jenis_protesa = val.content.jenis_protesa;
      this.material = val.content.material;
      this.warna = val.content.warna;
      this.elemen_gigi = Array.isArray(val.content.elemen_gigi)
        ? val.content.elemen_gigi.map((t) => Number(t))
        : [];
      this.indikasi_spesialistik = val.content.indikasi_spesialistik;
      this.tgl_pemasangan = val.content.tgl_pemasangan;
      this.catatan_pemasangan = val.content.catatan_pemasangan;
      this.surat_date = val.surat_date as Date;
      this.signee_user_id = val.signee_user_id;
      this.creator_user_id = val.creator_user_id;
    } else {
      this.register_id = this.register;
      this.pasien_rm = this.pasien.rm;
      this.unit_id = this.user.unit_id;
      this.umur = getAge(formatDMYDate(this.pasien.tgl_lahir))
        .toString()
        .concat(" Th");
      this.jenis_protesa = null;
      this.material = null;
      this.warna = null;
      this.elemen_gigi = [];
      this.indikasi_spesialistik = null;
      this.tgl_pemasangan = null;
      this.catatan_pemasangan = null;
      this.surat_date = new Date();
      this.signee_user_id = this.user.id;
      this.creator_user_id = this.user.id;
    }
  }

  save() {
    if (this.elemen_gigi.length === 0) {
      appModule.sendErrorAlert("Pilih minimal 1 elemen gigi");
      return;
    }

    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? this.suketSvc.update(this.dataSuket.id, this.input)
        : this.suketSvc.create(this.input);

      action
        .then(() => {
          if (this.canSign) {
            this.showSignatureModal();
          }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();
          StoreSuketKlaimProtesaGigi.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.expandInput = false;
  }

  @Watch("dataSuket")
  changeDataSuket(val: KlaimProtesaGigiWithRelationship) {
    this.fillFromData(val);
  }
}
